module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_6000.0799e2c8.png";